module.exports = __webpack_public_path__ + "static/media/circle_check.78abc8dd.svg";